import { formatNumber } from "@/utils/number-utils";
import { Link, ToOptions } from "@tanstack/react-router";
import { AnimatePresence, motion } from "framer-motion";

type TargetGroupCount = {
  targetGroupCount: number;
  potentialLeadCount: number | null;
  isFetchingCounts: boolean;
  isLoadingSuggestions: boolean;
  hasConfigsEnabled: boolean;
  isExpansionAvailable: boolean;
  linkProps: ToOptions;
};

export function TargetGroupCount({
  isFetchingCounts,
  isLoadingSuggestions,
  targetGroupCount,
  potentialLeadCount,
  hasConfigsEnabled,
  isExpansionAvailable,
  linkProps,
}: TargetGroupCount) {
  return (
    <AnimatePresence mode="wait">
      {isFetchingCounts ? (
        <motion.div
          key="loading-counts"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { delay: 1 } }} // Add delay to prevent flickering for fast loads
        >
          <div className="animate-pulse text-sm leading-6 font-semibold">
            Estimerer dine leads...
          </div>
        </motion.div>
      ) : (
        <motion.div
          key="target-group-count"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="flex flex-col items-start"
        >
          <div className="text-sm leading-6 font-semibold">
            <span>{formatNumber(targetGroupCount)}</span> i målgruppen
          </div>
          {isLoadingSuggestions ? (
            <motion.div
              key="loading-suggest"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="text-theme-active animate-pulse text-xs leading-4 font-medium"
            >
              Udvider målgruppen...
            </motion.div>
          ) : potentialLeadCount || hasConfigsEnabled ? (
            <motion.div
              key="advanced-link"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="text-theme-active cursor-pointer text-xs leading-4 font-medium"
            >
              <Link {...linkProps}>
                {potentialLeadCount && isExpansionAvailable ? (
                  <>Udvid med {formatNumber(potentialLeadCount)} flere</>
                ) : (
                  <>Tilpas segmenter</>
                )}
              </Link>
            </motion.div>
          ) : null}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
